CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Label = require 'models/label'

module.exports = class LabelList extends CollectionWithHelpers

  model: Label



// WEBPACK FOOTER //
// ./app/scripts/models/collections/label-list.coffee